import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaDataAprovacao = (): TabelaColuna => ({
  Chave: 'dataAprovacao',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.dataLocaleString(linha.dataAprovacao)}</span>
  ),
  RenderizarCabecalho: () => <div style={{ width: 90 }}>Data Aprovação</div>
})
